import axios from 'axios'
import router from '../router'
import store from './Store'

const api = axios.create({
    baseURL: process.env.VUE_APP_API,
    headers: {
        'Content-Type': 'application/json'
    },
    timeout: 10000,
    params: {} // do not remove this, its added to add params later in the config
});

api.interceptors.request.use(function (config) {

    let user = localStorage.getItem('user');
    if (user != null) {
        user = JSON.parse(user);
    }
    let header = null;

    if (user && user.access_token) {
        header = 'Bearer ' + user.access_token;
    }

    if (!header) {
        // return store.dispatch('refreshToken').then(() => {
        //     user = store.getters.USER;
        //     if (user) {
        //         config.headers.Authorization = 'Bearer ' + user.access_token;
        //     }
        //     return config;
        // });
    }
    else {
        if (header) {
            config.headers.Authorization = header;
        }
        return config;
    }

    return config;

}, function (error) {
    // Do something with request error
    return Promise.reject(error)
});

api.interceptors.response.use((response) => {
  return response;
}, function (error) {
  // Do something with response error
   if (error.response && error.response.status === 401) {
    console.log('unauthorized, logging out ...', error);

    store.commit('clearUser');
    store.commit('clearRefresh');
    router.push('/login');
  }
  return Promise.reject(error.response);
});

export default api
